import axios from "axios";
const jsonConfig = require("../Config.json");

const getAllDegrees = async () => {
    let allResponse = {}
    try {
        const getallresponse = await axios.get(
            jsonConfig.apiUrl + "getAlldegrees",
            {
              headers: {
                "x-functions-key": jsonConfig.key,
              },
            }
          );
        
        allResponse = getallresponse;
        return Promise.resolve(allResponse)
    }
    catch (error) {
      console.log("Error", error);
        return Promise.reject(error)
    }
};
export default getAllDegrees;
